import Judgement_Criteria from "../../assets/images/CodeUtsava_Judgement_7.0.pdf";


const faqs = [
  {
    question: "How do I register for the hackathon?",
    answer:
      "Click on any Register Now button on the website. Alternatively, you can head over to Devfolio." 
      
  },
  {
    question: "What is the participation fee?",
    answer:
      "Just some enthusiasm and an open mind are enough. We don't charge any money!!",
  },
  {
    question: "What if I don't have a team or idea?",
    answer:
      "We'll have team formation and ideation events geared towards helping you find a team. Make sure you join the discord server.",
  },
  {
    question: "Who can participate?",
    answer:
      "Everyone is welcome to apply, any student or working professionals. If you can innovate or just want to have a fun weekend, you are most welcome.",
  },
  {
    question: "When and how will the teams be shortlisted?",
    answer:
      "Shortlisting of teams will start from 15 october and will be based on the evaluation of individual resumes, and the final shortlisting decision will be determined by the combined results of those resumes. Final teams will be announced on 26th October!",
  },
  
  {
    question: "What could be the size of the team?",
    answer:
      "You can make teams of 2-4 members.",
  },
  {
    question: "Why should I participate in CodeUtsava 7.0?",
    answer:
      "You will get cash prizes if you win; otherwise, you will always get an excellent opportunity to network with like-minded people, learn many things and get cool schwag.😉",
  },
  {
    question: "What other perks are provided?",
    answer:
      "Accomodations and meals will be provided and travel expenses upto Rs.1500 per individual will be reimbursed for all the selected teams participating in CodeUtsava 7.0 !"
  },
  {
    question: "How will the teams be judged?",
    answer:<div>The teams will be judged based on Viability, Technical Complexity, Presentation Skills, Guidelines and most importantly, Creativity. <a href={Judgement_Criteria}style={{color:'#0077ee' , textDecoration:'underline'}}>JUDEMENT CRITERIA</a></div>
  },
  {
    question: "What is the Code of Conduct?",
    answer:
      "To ensure a positive experience among all the participants, we follow the SIH Code of Conduct. It is advised that you go through it once.",
  },
];

export default faqs;
